<template>
    <div class="import-feedback-drawer-guide-bar-card__guide-card">
        <span class="import-feedback-drawer-guide-bar-card__title">
            {{ selectedSourceText }}
        </span>
        <pendo-divider
            direction="vertical"
            decorative
            width="32px" />
        <div class="import-feedback-drawer-guide-bar-card__guide-name-wrapper">
            <pendo-router-link
                :to="redirectTo"
                target="_blank">
                <pendo-button
                    class="import-feedback-drawer-guide-bar-card__guide-name"
                    :label="guide.name"
                    theme="app"
                    height="20px"
                    type="subtle" />
            </pendo-router-link>
            <pendo-icon
                type="external-link"
                size="14"
                stroke="var(--palette-teal-80)"
                class="import-feedback-drawer-guide-bar-card__external-icon" />
        </div>
        <pendo-divider
            direction="vertical"
            decorative
            width="32px" />
        <pendo-app-cell :row="guide.appItem" />
        <pendo-divider
            direction="vertical"
            decorative
            width="32px" />
        <pendo-group-cell :row="guide" />
    </div>
</template>
<script>
import { PendoDivider, PendoButton, PendoIcon, PendoAppCell, PendoGroupCell } from '@pendo/components';
import PendoRouterLink from '@/vue-router/pendo-router-link.vue';
import { MESSAGE_TYPES } from '@/orchestrate/journeys/constants.js';

const { EMAIL } = MESSAGE_TYPES;

export default {
    name: 'ImportFeedbackDrawerGuideBarCard',
    components: {
        PendoDivider,
        PendoButton,
        PendoIcon,
        PendoAppCell,
        PendoGroupCell,
        PendoRouterLink,
    },
    props: {
        guide: {
            type: [Object, null],
            required: true,
        },
        type: {
            type: String,
            default: 'Guide',
        },
    },
    computed: {
        selectedSourceText () {
            return `${this.type}:`;
        },
        redirectTo () {
            return this.type === EMAIL
                ? { name: 'EmailDetails', params: { id: this.guide.id } }
                : { name: 'GuideDetails', params: { guideId: this.guide.id } };
        },
    },
};
</script>
<style lang="less" scoped>
@import '@/voc/styles/voc.style.less';

.import-feedback-drawer-guide-bar-card {
    &__title {
        font-weight: 600;
    }
    &__guide-card {
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
        row-gap: 6px;
        line-height: 120%;
        background: var(--palette-gray-10);
        border-radius: 3px;
        border: 1px solid var(--palette-gray-40);
        margin-top: 16px;
        padding: 10px 32px;
    }
    &__external-icon {
        opacity: 0;
        position: absolute;
        right: -20px;
        top: 1px;
        pointer-events: none;
    }
    &__guide-name-wrapper {
        position: relative;
        &:hover {
            .import-feedback-drawer-guide-bar-card__external-icon {
                opacity: 1;
            }
        }
    }
    &__guide-name {
        height: 20px;
    }
}
</style>
